import React, { useState } from "react";
import "./styles.scss";
import { Row, Col } from "react-bootstrap";
import ArchivedWorkshopSideBarHeader from "../../components/header/ArchivedWorkshopSideBarHeader";
import CustomMenu from "../../../../../../../../../shared/components/CustomMenu/CustomMenu";
import { useHistory, useLocation } from "react-router-dom";
import { useAppUser } from "../../../../../../../../../contexts/user-context/UserContext";
import SelectCountry from "../../../../../../../../../shared/components/countrySelectorModal/SelectCountry";
import { DashboardArchevedWorkshopPages } from "../../../../../../../containers/archive/containers/ArchivedLibrary";
import { useWorkshops } from "../../../../../../../../../contexts/workshops-context/WorkshopsContext";

interface IProps {
  type: "PUBLIC" | "PRIVATE";
}

const SubMenuArchivedWorkshops = (props: IProps) => {
  const { pathname } = useLocation();
  const [modalShow, setModalShow] = useState(false);
  const workshops = useWorkshops();
  const appUser = useAppUser();
  const history = useHistory();

  return (
    <>
      <Row>
        <Col xs={12}>
          <ArchivedWorkshopSideBarHeader {...props} />
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <CustomMenu
            data={[
              {
                onClick: () => {
                  if (workshops.country !== "DEFAULT") {
                    history.push(DashboardArchevedWorkshopPages.WORKSHOPS);
                  } else {
                    setModalShow(true);
                  }
                },
                text: "Workshops",
                isActive: pathname === DashboardArchevedWorkshopPages.WORKSHOPS,
              },
            ]}
          />
          {appUser.userRole.isModerator && (
            <CustomMenu
              data={[
                {
                  onClick: () => {
                    if (workshops.country !== "DEFAULT") {
                      history.push(DashboardArchevedWorkshopPages.SECTIONS);
                    } else {
                      setModalShow(true);
                    }
                  },
                  text: "Sections",
                  isActive:
                    pathname === DashboardArchevedWorkshopPages.SECTIONS,
                },
              ]}
            />
          )}
        </Col>
      </Row>
      {appUser.userRole.isAdmin && props.type === "PRIVATE" && (
        <SelectCountry
          show={modalShow}
          onHide={() => {
            setModalShow(false);
          }}
        />
      )}
    </>
  );
};

export default SubMenuArchivedWorkshops;
